shadow$provide[202] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Interval:{enumerable:true, get:function() {
  return Interval;
}}});
var require$_DOT__SLASH_array_DOT_js = require("./array.js");
class Interval extends require$_DOT__SLASH_array_DOT_js.Array_ {
  static initClass() {
    this.traits = ["node", "buffer", "active", "data", "source", "index", "texture", "array", "span", "interval", "sampler", "raw",];
  }
  updateSpan() {
    let inverse;
    const dimension = this.props.axis;
    let {width} = this.props;
    const {centered} = this.props;
    const pad = this.props.padding;
    const range = this._helpers.span.get("", dimension);
    width += pad * 2;
    this.a = range.x;
    const span = range.y - range.x;
    if (centered) {
      inverse = 1 / Math.max(1, width);
      this.a += span * inverse / 2;
    } else {
      inverse = 1 / Math.max(1, width - 1);
    }
    this.b = span * inverse;
    return this.a += pad * this.b;
  }
  callback(callback) {
    this.updateSpan();
    if (this.last === callback) {
      return this._callback;
    }
    this.last = callback;
    if (callback.length <= 3) {
      return this._callback = (emit, i) => {
        const x = this.a + this.b * i;
        return callback(emit, x, i);
      };
    } else {
      return this._callback = (emit, i) => {
        const x = this.a + this.b * i;
        return callback(emit, x, i, this.bufferClock, this.bufferStep);
      };
    }
  }
  make() {
    super.make();
    this._helpers.span.make();
    return this._listen(this, "span.range", this.updateSpan);
  }
  unmake() {
    super.unmake();
    return this._helpers.span.unmake();
  }
  change(changed, touched, init) {
    super.change(changed, touched, init);
    if (touched["span"]) {
      this.updateSpan();
    }
  }
}
Interval.initClass();

};